// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2Oick","large":"styles_large__glQne"};